import getDecorators from "inversify-inject-decorators";
import container from "../../../ioc/inversify.config";
import { DefaultSelectable } from "../../menu/interfaces";
import { TextContent } from "../text-content";

const { lazyInject } = getDecorators(container);

export class TitleScreenOption extends DefaultSelectable {
    private paddingY = 0;
    private paddingX = 0;

    private _optionName: TextContent;

    constructor(x: number, y: number, _optionName: string, scene: Phaser.Scene) {
        super(scene, x, y);
        this._optionName = new TextContent(
            x + this.paddingX,
            y + this.paddingY,
            _optionName,
            scene
        );
        this.width = this._optionName.getBounds().width;
        this.height = this._optionName.getBounds().height;

        this.add(this._optionName);
    }

    get textWidth(): number {
        return this._optionName.getBounds().width;
    }

    get textHeight(): number {
        return this._optionName.getBounds().height;
    }

    get optionName(): string {
        return this._optionName.text;
    }
}
